import { render, staticRenderFns } from "./UploadDocumentModalComponent.vue?vue&type=template&id=9dd29558&scoped=true&"
import script from "./UploadDocumentModalComponent.vue?vue&type=script&lang=js&"
export * from "./UploadDocumentModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./UploadDocumentModalComponent.vue?vue&type=style&index=0&id=9dd29558&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd29558",
  null
  
)

export default component.exports